import React from "react";
import { Tooltip } from "antd";

/**
 * Показывает Tooltip для disabled-детей (например, Button).
 * Оборачивает детей в <span> ТОЛЬКО когда disabled === true.
 *
 * Props:
 *  - disabled: boolean          // когда true — включаем обёртку с тултипом
 *  - title: ReactNode           // текст/нода тултипа
 *  - placement: string = "top"  // позиция тултипа (antd)
 *  - block: boolean = true      // занять всю ширину (для кнопок block)
 *  - className: string          // классы на wrapper <span>
 *  - align, mouseEnterDelay, mouseLeaveDelay — проброс в Tooltip
 */
const TooltipWrapper = ({
                            disabled,
                            title,
                            placement = "top",
                            block = true,
                            className,
                            align,
                            mouseEnterDelay = 0.1,
                            mouseLeaveDelay = 0.1,
                            children,
                        }) => {
    if (!disabled || !title) return children;

    const style = block
        ? { display: "block", width: "100%" }
        : { display: "inline-block" };

    return (
        <Tooltip
            title={title}
            placement={placement}
            align={align}
            mouseEnterDelay={mouseEnterDelay}
            mouseLeaveDelay={mouseLeaveDelay}
        >
      <span className={className} style={style}>
        {children}
      </span>
        </Tooltip>
    );
};

export default TooltipWrapper;
